module.exports = __webpack_public_path__ + "img/4_3.ee47dbfd.png";